import React from 'react';
import { CheckboxInput } from '@instinet-analytics/semantic-ui-components';
import './CorporateActionsDateQuickFilter.scss';

export interface CorporateActionsDateQuickFilterProps {
    upcoming: boolean;
    historical: boolean;
    today: boolean;
    onChange: (next: {
        upcoming: boolean;
        historical: boolean;
        today: boolean;
    }) => void;
}

export function CorporateActionsDateQuickFilter(
    props: CorporateActionsDateQuickFilterProps
) {
    const { historical, upcoming, today, onChange } = props;

    const onHistoricalToggled = () => {
        const nextHistorical = !historical;
        onChange({
            historical: nextHistorical,
            upcoming,
            today,
        });
    };
    const onUpcomingToggled = () => {
        const nextUpcoming = !upcoming;

        onChange({
            historical,
            upcoming: nextUpcoming,
            today,
        });
    };
    const onTodayToggled = () => {
        const nextTodayQuickFilter = !today;
        onChange({
            historical: historical,
            upcoming: upcoming,
            today: nextTodayQuickFilter,
        });
    };

    return (
        <div className="CorporateActionsDateQuickFilter ui">
            <CheckboxInput
                className={'include-historical'}
                checked={historical}
                onToggle={onHistoricalToggled}
                label={'Hist'}
            />
            <CheckboxInput
                className={'include-upcoming'}
                checked={upcoming}
                onToggle={onUpcomingToggled}
                label={'Fut'}
            />
            <CheckboxInput
                className={'include-today'}
                checked={today}
                onToggle={onTodayToggled}
                label={'Today'}
            />
        </div>
    );
}
